export default {
  typeColor: {
    0: 'green',
    1: 'warning',
    2: 'info',
    3: 'deep-purple'
  },
  typeText: {
    0: 'Main',
    1: 'Custom',
    2: 'Bigger',
    3: 'Dtnt'
  },
  statuses: {
    ACTIVE: 0,
    INACTIVE: 1,
    DELETED: 2
  },
  statusColor: {
    0: 'green',
    1: 'blue-grey',
    2: 'grey'
  },
  statusText: {
    0: 'Active',
    1: 'Inactive',
    2: 'Deleted'
  },
  packageStatusSelect: [
    { text: 'Active', value: 0, shortText: 'Act' },
    { text: 'Inactive', value: 1, shortText: 'Inact' },
    { text: 'Deleted', value: 2, shortText: 'Del' }
  ],
  // packageStatusSelect: [
  //   { text: 'No Package', value: 0, shortText: 'NoPack' },
  //   { text: 'Active Package', value: 1, shortText: 'Active' },
  //   { text: 'Expired Package', value: 2, shortText: 'Expired' },
  //   { text: 'Active Trial Package', value: 3, shortText: 'Trial' },
  //   { text: 'Expired Trial Package', value: 4, shortText: 'ExpTrial' }
  // ]
  packageType: {
    MAIN: 0,
    CUSTOM: 1,
    BIGGER: 2,
    DTNT: 3
  },
  packageTypeSelect: [
    { text: 'Main', value: 0, shortText: 'Main' },
    { text: 'Custom', value: 1, shortText: 'Custom' },
    { text: 'Bigger', value: 2, shortText: 'Bigger' },
    { text: 'Dtnt', value: 3, shortText: 'Dtnt' }
  ],
  attributesType: {
    MIN_MAX: 0,
    SCANS: 1,
    LIST: 2,
    RANGE: 3,
    BOOL: 4,
    EXTRA: 5
  },
  wizardType: {
    MAIN: 0,
    CUSTOM: 1,
    BIGGER: 2
  },
  attributes: {
    projects_count: {
      description: 'Projects count',
      type: 0,
      flex: false,
      value: 1
    },
    projects_count_extra: {
      description: 'Projects extra count',
      type: 5,
      flex: true,
      value: 0
    },
    keywords_count: {
      description: 'Keywords count',
      type: 0,
      flex: false,
      value: 50
    },
    keywords_count_extra: {
      description: 'Keywords extra count',
      type: 5,
      flex: true,
      value: 0
    },
    // links_count: {
    //   description: 'Links count',
    //   type: 0,
    //   flex: false,
    //   value: 0
    // },
    // links_count_extra: {
    //   description: 'Links count extra',
    //   type: 5,
    //   flex: true,
    //   value: 0
    // },
    reports_count: {
      description: 'Reports count',
      type: 0,
      flex: false,
      value: 0
    },
    reports_count_extra: {
      description: 'Reports extra count',
      type: 5,
      flex: true,
      value: 0
    },
    main_competitors_count: {
      description: 'Number of competitors attached to project',
      type: 0,
      flex: false,
      value: 0
    },
    main_competitors_count_extra: {
      description: 'Number of extra competitors attached to project',
      type: 5,
      flex: false,
      value: 0
    },
    comparing_competitors_count: {
      description: 'Comparing ranking for X competitors in project',
      type: 0,
      flex: false,
      extras: {},
      value: 0
    },
    comparing_competitors_count_extra: {
      description: 'Comparing ranking for X extra competitors in project',
      type: 5,
      flex: false,
      value: 0
    },
    weekly_scans: {
      description: 'Keywords scans per week',
      type: 1,
      flex: false,
      items: 'weeklyScansSelect',
      extras: {},
      value: 1
    },
    // links_period: {
    //   description: 'Links updating period',
    //   type: 1,
    //   flex: false,
    //   items: 'linksPeriodSelect',
    //   extras: {},
    //   value: 0
    // },
    allowed_engine_ids: {
      description: 'Allowed searching engines',
      type: 2,
      flex: false,
      items: 'selectAllEngines',
      extras: {},
      value: [1]
    },
    allowed_report_ids: {
      description: 'Allowed reports',
      type: 2,
      flex: false,
      items: 'selectReports',
      extras: {},
      value: [] // reports
    },
    allowed_trends_filters: {
      description: 'Allowed 30 days trends ranking table filters',
      type: 2,
      flex: false,
      items: 'rankingTrendsFilterTypeSelect',
      extras: {},
      value: [] // RankingTrendsFilterType
    },
    changes_tab_urls_table_filters: {
      description: 'Allowed URL changes table filters',
      type: 2,
      flex: false,
      items: 'changesTabUrlFilterTypeSelect',
      extras: {},
      value: [] // RankingTrendsFilterType
    },
    scraping_depth: {
      description: 'Depth of google results scanned',
      type: 3,
      flex: false,
      items: 'scrapingDepthSelect',
      extras: {},
      value: 30
    },
    report_lines_limit: {
      description: 'Max lines per report',
      type: 3,
      flex: false,
      items: 'reportLinesLimitSelect',
      extras: {},
      value: 0
    },
    history_months: {
      description: 'Months of history available to kolyom data',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    // links_chart: {
    //   description: 'Links chart',
    //   type: 3,
    //   flex: false,
    //   items: 'dateRangeTypeSelect',
    //   extras: {},
    //   value: 0 // DateRangeType
    // },
    keywords_suggestions_type: {
      description: 'Keywords suggestion type',
      type: 3,
      flex: false,
      items: 'keywordSuggestionTypesSelect',
      extras: {},
      value: 10 // KeywordSuggestionType
    },
    weather_type: {
      description: 'Weather graphs - google updates',
      type: 3,
      flex: false,
      items: 'weatherGraphTypeSelect',
      extras: {},
      value: 0 // WeatherGraphType
    },
    traffic_history_months: {
      description: 'The number of traffic history months',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    average_ranking_table_type: {
      description: 'Average ranking table',
      type: 3,
      flex: false,
      items: 'rankingAveragesDateRangeTypeSelect',
      extras: {},
      value: 0 // RankingAveragesDateRangeType
    },
    keywords_count_chart_type: {
      description: 'Keywords count chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    indexed_pages_chart_type: {
      description: 'Indexed pages chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    ranking_chart_type: {
      description: 'Ranking chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 10 // DateRangeType
    },
    traffic_chart_type: {
      description: 'Traffic chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    changes_chart_type: {
      description: 'Changes chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 10 // DateRangeType
    },
    averages_chart_type: {
      description: 'Averages chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    keyword_urls_ranking_chart_type: {
      description: 'Ranking (by URL)',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    keyword_ranking_stability_chart_type: {
      description: 'Ranking Stability Monitor chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    featured_snippet_chart_type: {
      description: 'Featured snippets chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    // algo_check_report_count: {
    //   description: 'Algo-check report count',
    //   type: 0,
    //   flex: false,
    //   value: 0
    // },
    // algo_check_report_count_extra: {
    //   description: 'Algo-check report extra count',
    //   type: 5,
    //   flex: true,
    //   value: 0
    // },
    scrap_now: {
      description: 'Allow to refresh keywords manually',
      type: 4,
      flex: false,
      value: false
    },
    volume_updater_enable: {
      description: 'Monthly search volume',
      type: 4,
      flex: false,
      value: false
    },
    show_xlsx: {
      description: 'View kolyom data on kolyom site',
      type: 4,
      flex: false,
      value: false
    },
    download_xlsx: {
      description: 'Download kolyom data as Excel report',
      type: 4,
      flex: false,
      value: false
    },
    // linking_page_enable: {
    //   description: 'Anchor Text Distribution',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // links_strength: {
    //   description: 'Links strength',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // deep_link_ratio: {
    //   description: 'Deep link ratio',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // linking_page_word_count: {
    //   description: 'Linking page word count',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // links_view_log: {
    //   description: 'View links log',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // links_view_details: {
    //   description: 'View links details',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // links_box: {
    //   description: 'Links box',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // juice_links_box: {
    //   description: 'Links juice box',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // bad_links_box: {
    //   description: 'Bad links box',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // lost_links_chart: {
    //   description: 'Lost links chart',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // bad_links_chart: {
    //   description: 'Bad links chart',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // links_strength_chart: {
    //   description: 'Links strength chart',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    // project_links_table: {
    //   description: 'Project links table',
    //   type: 4,
    //   flex: false,
    //   value: false
    // },
    suggested_keywords_box: {
      description: 'Top suggested keywords box',
      type: 4,
      flex: false,
      value: true
    },
    automatic_keywords_switch: {
      description: 'Switching automatic keywords added to project on a weekly basis',
      type: 4,
      flex: false,
      value: false
    },
    subfinder: {
      description: 'Sub-finder tool',
      type: 4,
      flex: false,
      value: false
    },
    default_goals: {
      // description: 'Default goals quota set (content, links, 1st page keywords)',
      description: 'Default goals quota set (content, 1st page keywords)',
      type: 4,
      flex: false,
      value: false
    },
    custom_goals: {
      description: 'Custom goal',
      type: 4,
      flex: false,
      value: false
    },
    autofinding_competitors: {
      description: 'Automatic find competitors for project',
      type: 4,
      flex: false,
      value: false
    },
    pages_performance_table: {
      description: 'Pages performance table',
      type: 4,
      flex: false,
      value: false
    },
    monitored_ranking_enable: {
      description: 'Monitored/Ranking feature',
      type: 4,
      flex: false,
      value: true
    },
    changes_column_enable: {
      description: 'Changes in keywords - ups, downs, entries, exits, 1st page entries and exits',
      type: 4,
      flex: false,
      value: true
    },
    user_offers_enable: {
      description: 'Support',
      type: 4,
      flex: false,
      value: false
    },
    mailer_enable: {
      description: 'Mail notifications',
      type: 4,
      flex: false,
      value: true
    },
    ranking_diagram: {
      description: 'Ranking summary diagram',
      type: 4,
      flex: false,
      value: false
    },
    predicted_traffic: {
      description: 'Predicted traffic',
      type: 4,
      flex: false,
      value: false
    },
    top_competitors_box: {
      description: 'Top competitors box',
      type: 4,
      flex: false,
      value: false
    },
    indexed_pages_box: {
      description: 'Indexed pages box',
      type: 4,
      flex: false,
      value: false
    },
    tagging_keywords: {
      description: 'Tagging keywords',
      type: 4,
      flex: false,
      value: true
    },
    project_changes_count: {
      description: 'Project changes count',
      type: 4,
      flex: false,
      value: true
    },
    leaderboard_rank: {
      description: 'Leaderboard rank',
      type: 4,
      flex: false,
      value: true
    },
    domain_rank: {
      description: 'Domain rank',
      type: 4,
      flex: false,
      value: true
    },
    competitors_on_rise_table: {
      description: 'Competitors on rise table',
      type: 4,
      flex: false,
      value: false
    },
    deep_diving_box: {
      description: 'Deep diving box',
      type: 4,
      flex: false,
      value: false
    },
    top_rising_keywords_box: {
      description: 'Top rising keywords box',
      type: 4,
      flex: false,
      value: false
    },
    custom: {
      description: 'Custom product',
      type: 4,
      flex: false,
      value: false
    },
    featured_snippet: {
      description: 'Featured snippet',
      type: 4,
      flex: false,
      value: false
    },
    zoom_meetings: {
      description: 'Zoom meetings',
      type: 4,
      flex: false,
      value: false
    },
    workspaces_count: {
      description: 'Workspaces count',
      type: 0,
      flex: false,
      value: 0
    },
    workspaces_count_extra: {
      description: 'Workspaces extra count',
      type: 5,
      flex: true,
      value: 0
    },
    competitors_workspaces_count: {
      description: 'Competitors Workspaces count',
      type: 0,
      flex: false,
      value: 0
    },
    competitors_workspaces_count_extra: {
      description: 'Competitors Workspaces extra count',
      type: 5,
      flex: true,
      value: 0
    },
    user_zero_coupons_count: {
      description: 'User Zero-Price coupons count',
      type: 0,
      flex: false,
      value: 0
    },
    user_zero_coupons_count_extra: {
      description: 'User Zero-Price coupons extra count',
      type: 5,
      flex: false,
      value: 0
    },
    split_package: {
      description: 'Allows to split package',
      type: 4,
      flex: false,
      value: false
    },
    keyword_competition: {
      description: 'Keyword competition',
      type: 4,
      flex: false,
      value: false
    },
    keyword_cost_per_click: {
      description: 'Keyword cost per click',
      type: 4,
      flex: false,
      value: false
    },
    keyword_categories: {
      description: 'Keyword categories',
      type: 4,
      flex: false,
      value: false
    },
    video_private: {
      description: 'Private videos',
      type: 4,
      flex: false,
      value: false
    },
    backpack: {
      description: 'Backpack',
      type: 4,
      flex: false,
      value: false
    },
    budget_calculator: {
      description: 'Budget Calculator',
      type: 4,
      flex: false,
      value: false
    },
    urls_traffic_count: {
      description: 'Urls traffic count',
      type: 0,
      flex: false,
      value: 0
    },
    urls_traffic_count_extra: {
      description: 'Urls traffic extra count',
      type: 5,
      flex: false,
      value: 0
    },
    volumes_chart_type: {
      description: 'Keyword volumes chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    volume_year_changes: {
      description: 'Keyword volume changes per year',
      type: 4,
      flex: false,
      value: false
    },
    total_cpc_chart_type: {
      description: 'Site Organic Value chart',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    organic_traffic_value: {
      description: 'Organic Traffic Value',
      type: 4,
      flex: false,
      value: false
    },
    recently_trending_keywords: {
      description: 'Recently Trending Keywords',
      type: 4,
      flex: false,
      value: false
    },
    loosing_popularity_keywords: {
      description: 'Loosing Popularity Keywords',
      type: 4,
      flex: false,
      value: false
    },
    pages_ranking_ratio: {
      description: 'Pages Ranking Ratio',
      type: 4,
      flex: false,
      value: false
    },
    pages_gaining_traffic: {
      description: 'Pages Gaining Traffic',
      type: 4,
      flex: false,
      value: false
    },
    pages_lost_traffic: {
      description: 'Pages Lost Traffic',
      type: 4,
      flex: false,
      value: false
    },
    keywords_fishing_tool: {
      description: 'Keywords Fishing Tool',
      type: 4,
      flex: false,
      value: false
    },
    long_tail_research_tool: {
      description: 'Long Tail Research Tool',
      type: 4,
      flex: false,
      value: false
    },
    keywords_best_categories: {
      description: 'Best categories by keywords',
      type: 4,
      flex: false,
      value: false
    },
    keywords_best_categories_chart_type: {
      description: 'Volumes chart for best categories by keywords',
      type: 3,
      flex: false,
      items: 'dateRangeTypeSelect',
      extras: {},
      value: 0 // DateRangeType
    },
    keyword_frequency: {
      description: 'Text Analysis: Words Count & Frequency',
      type: 4,
      flex: false,
      value: false
    },
    site_visibility: {
      description: 'Site Visibility',
      type: 4,
      flex: false,
      value: false
    },
    view_tags_table: {
      description: 'Tags View table',
      type: 4,
      flex: false,
      value: false
    },
    view_tags_competitor_table: {
      description: 'Competitors View (by tags)',
      type: 4,
      flex: false,
      value: false
    },
    global_level_type: {
      description: 'Clients Reports/Dashboards level',
      type: 3,
      flex: false,
      items: 'globalLevelTypeSelect',
      extras: {},
      value: 0 // globalLevelType
    },
    global_reports_count: {
      description: 'Clients Reports count',
      type: 0,
      flex: false,
      value: 0
    },
    global_reports_count_extra: {
      description: 'Urls traffic extra count',
      type: 5,
      flex: false,
      value: 0
    },
    indexed_page_not_serps: {
      description: 'Fix or Remove non-helpful content',
      type: 4,
      flex: false,
      value: false
    },
    long_title_urls: {
      description: 'URLs with long titles',
      type: 4,
      flex: false,
      value: false
    },
    avg_ctr_chart: {
      description: 'Avg CTR chart',
      type: 4,
      flex: false,
      value: false
    },
    avg_ctr_keywords_table: {
      description: 'Keywords avg CTR table',
      type: 4,
      flex: false,
      value: false
    },
    google_account_projects_only: {
      description: 'Projects with Google account only',
      type: 4,
      flex: false,
      value: false
    },
    x_traffic: {
      description: 'X traffic - shows how much traffic you can gain',
      type: 4,
      flex: false,
      value: false
    },
    marketplace_element_level: {
      description: 'Level of access for marketplace elements',
      type: 3,
      flex: false,
      items: 'MarketplaceElementLevel',
      extras: {},
      value: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/plan/state.js